import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Text from "@amzn/meridian/esm/components/text";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import LearnMoreLink from "./LearnMoreLink";
import WaveformLayout from "./waveformLayout/WaveformLayout";
import { scaleIconClass } from "../styles/icon.styles";
import { WAVEFORM_ICON_SCALE } from "../constants";

/**
 * NotAvailable - waveform + warning icon over a title, used wherever something is
 * unavailable: the whole assistant (with a reason and a Learn more link), or a single
 * insight tab whose meeting has no insights (title only).
 */
const NotAvailable = ({ title, message, showLearnMore = true }) => (
  <WaveformLayout icon={<Icon className={scaleIconClass(WAVEFORM_ICON_SCALE)} tokens={alertTokens} color="warning" />}>
    <Column spacing="400">
      <Text type="h50">{title}</Text>
      {message && <Text type="b200">{message}</Text>}
      {showLearnMore && <LearnMoreLink />}
    </Column>
  </WaveformLayout>
);

export default NotAvailable;
